<script>
import {
  required,
  requiredIf,
  integer,
  minValue,
  maxValue,
  helpers
} from 'vuelidate/lib/validators'

const isEven = value => !helpers.req(value) || value % 2 === 0

export default {
  name: 'alu-casing.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      specs: {
        build_casing: false,
        add_head_support: false,
        add_foot_support: false,
        add_abduction: false,
        add_table_system: false,
        add_arm_support: false,
        head_support_foam_size: null,
        head_support_foam_model: null,
        foot_support_tube_length: null,
        foot_support_abs_plate: null,
        foot_support_footplates: null,
        max_foam_enabled: false,
        max_foam_width: 0
      },
      ...vm.value
    }
  }),
  validations () {
    let validations = {
      form: {
        specs: {
          head_support_foam_size: {
            required: requiredIf(model => model.add_head_support)
          },
          head_support_foam_model: {
            required: requiredIf(
              model =>
                model.add_head_support &&
                model.head_support_foam_size !== 'milled'
            )
          },
          foot_support_tube_length: {
            required: requiredIf(model => model.add_foot_support)
          },
          foot_support_abs_plate: {
            required: requiredIf(model => model.add_foot_support)
          },
          foot_support_footplates: {
            required: requiredIf(model => model.add_foot_support)
          },
          max_foam_width: {
            required: requiredIf(model => model.max_foam_enabled),
            integer,
            isEven
          }
        }
      }
    }
    return validations
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    }
  },
  computed: {}
}
</script>
<template>
  <b-row>
    <b-col cols="12">
      <b-form-checkbox
        id="build_casing"
        class="mb-4 mt-2"
        v-model="form.specs.build_casing"
        name="build_casing"
      >
        {{ $t('Build Alumnium Casing') }}
      </b-form-checkbox>

      <template v-if="form.specs.build_casing">
        <b-form-checkbox
          id="head_support"
          class="my-4"
          v-model="form.specs.add_head_support"
          name="head_support"
        >
          {{ $t('Add Head Support System') }}
        </b-form-checkbox>

        <template v-if="form.specs.add_head_support">
          <g-form-error-wrapper
            :validations="$v.form.specs.head_support_foam_size"
          >
            <template v-slot="{ errors, invalid }">
              <g-select
                :label="$t('attribute.size.key')"
                label-cols-sm="6"
                label-cols-lg="4"
                class="align-items-center"
                max-width="180px"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:change="$v.form.specs.head_support_foam_size.$touch()"
                v-model="form.specs.head_support_foam_size"
                :options="[
                  {
                    value: null,
                    text: $t('- Select Size -')
                  },
                  { value: 'small', text: $t('attribute.size.small') },
                  { value: 'medium', text: $t('attribute.size.medium') },
                  { value: 'large', text: $t('attribute.size.large') },
                  { value: 'milled', text: $t('attribute.size.milled') }
                ]"
                button-variant="outline-primary"
              >
              </g-select>
            </template>
          </g-form-error-wrapper>

          <g-form-error-wrapper
            :validations="$v.form.specs.head_support_foam_model"
            v-if="
              form.specs.head_support_foam_size !== 'milled' &&
              form.specs.head_support_foam_size
            "
          >
            <template v-slot="{ errors, invalid }">
              <g-select
                :label="$t('attribute.head_support_foam_model.key')"
                label-cols-sm="6"
                label-cols-lg="4"
                class="align-items-center"
                max-width="190px"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:change="$v.form.specs.head_support_foam_model.$touch()"
                v-model="form.specs.head_support_foam_model"
                :options="[
                  { value: null, text: '- Select Model Type -' },
                  {
                    value: 'normal',
                    text: $t('attribute.head_support_foam_model.normal')
                  },
                  {
                    value: 'deep',
                    text: $t('attribute.head_support_foam_model.deep')
                  }
                ]"
                button-variant="outline-primary"
              >
              </g-select>
            </template>
          </g-form-error-wrapper>
        </template>

        <b-form-checkbox
          id="foot_support"
          class="my-4"
          v-model="form.specs.add_foot_support"
          name="foot_support"
        >
          {{ $t('Add Foot Support System') }}
        </b-form-checkbox>

        <template v-if="form.specs.add_foot_support">
          <g-form-error-wrapper
            :validations="$v.form.specs.foot_support_tube_length"
          >
            <template v-slot="{ errors, invalid }">
              <g-select
                :label="$t('attribute.tube_length.key')"
                label-cols-sm="6"
                label-cols-lg="4"
                class="align-items-center"
                max-width="150px"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:change="$v.form.specs.foot_support_tube_length.$touch()"
                v-model="form.specs.foot_support_tube_length"
                :options="[
                  {
                    value: null,
                    text: $t('- Select Length -')
                  },

                  { value: 25, text: '25cm' },
                  { value: 30, text: '30cm' },
                  { value: 35, text: '35cm' },
                  { value: 40, text: '40cm' },
                  { value: 45, text: '45cm' }
                ]"
                button-variant="outline-primary"
              >
              </g-select>
            </template>
          </g-form-error-wrapper>
          <g-form-error-wrapper
            :validations="$v.form.specs.foot_support_abs_plate"
          >
            <template v-slot="{ errors, invalid }">
              <g-select
                v-model.number="form.specs.foot_support_abs_plate"
                :label="$t('attribute.foot_support_abs_plate.key')"
                :options="[
                  {
                    value: null,
                    text: $t('- Select Depth -')
                  },
                  { value: 20, text: '20cm' },
                  { value: 25, text: '25cm' },
                  { value: 30, text: '30cm' },
                  { value: 35, text: '35cm' },
                  { value: 40, text: '40cm' },
                  { value: 45, text: '45cm' },
                  {
                    value: 'none',
                    text: $t('attribute.foot_support_abs_plate.none')
                  }
                ]"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:change="$v.form.specs.foot_support_abs_plate.$touch()"
                label-cols-sm="6"
                label-cols-lg="4"
                max-width="180px"
              >
              </g-select>
            </template>
          </g-form-error-wrapper>
          <g-form-error-wrapper
            :validations="$v.form.specs.foot_support_footplates"
          >
            <template v-slot="{ errors, invalid }">
              <g-select
                :label="$t('attribute.foot_support_footplates.key')"
                label-cols-sm="6"
                label-cols-lg="4"
                class="align-items-center"
                v-model="form.specs.foot_support_footplates"
                max-width="180px"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:change="$v.form.specs.foot_support_footplates.$touch()"
                :options="[
                  { value: null, text: $t('- Select Size -') },
                  { value: 15, text: '15cm' },
                  { value: 17, text: '17cm' },
                  { value: 20, text: '20cm' },
                  { value: 23, text: '23cm' },
                  { value: 25, text: '25cm' },
                  { value: 27, text: '27cm' },
                  {
                    value: 'none',
                    text: $t('attribute.foot_support_footplates.none')
                  }
                ]"
                button-variant="outline-primary"
              >
              </g-select>
            </template>
          </g-form-error-wrapper>
        </template>

        <b-form-checkbox
          id="abduction"
          class="my-4"
          v-model="form.specs.add_abduction"
          name="abduction"
        >
          {{ $t('attribute.add_abduction.key') }}
        </b-form-checkbox>

        <b-form-checkbox
          id="arm-support"
          class="my-4"
          v-model="form.specs.add_arm_support"
          name="arm-support"
        >
          {{ $t('attribute.add_arm_support.key') }}
        </b-form-checkbox>

        <b-form-checkbox
          id="table-support"
          class="my-4"
          v-model="form.specs.add_table_system"
          name="table-support"
        >
          {{ $t('attribute.add_table_system.key') }}
        </b-form-checkbox>

        <div class="d-flex align-items-center justify-content-start m-0">
          <b-form-checkbox
            id="max_foam_width"
            class=""
            v-model="form.specs.max_foam_enabled"
            name="max_foam_width"
          >
            {{ $t('Max. Foam Width') }}
          </b-form-checkbox>

          <g-form-error-wrapper
            :validations="$v.form.specs.max_foam_width"
            class="mx-3 p-0 m-0"
            v-if="form.specs.max_foam_enabled"
          >
            <template v-slot="{ errors, invalid }">
              <g-text-input
                v-model.number="form.specs.max_foam_width"
                :label="null"
                append="cm"
                maxWidth="100px"
                text-align="center"
                :error-messages="errors"
                :is-valid="!invalid"
                v-on:blur="$v.form.specs.max_foam_width.$touch()"
                label-cols-sm="0"
                :disabled="!form.specs.max_foam_enabled"
              >
              </g-text-input>
            </template>
          </g-form-error-wrapper>
        </div>
      </template>
    </b-col>
  </b-row>
</template>
